// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Xq3x","rootSmall":"AddTileButton_rootSmall__2Xs9F"};